import ServicePage from "@/components/ServicePage";

const Systems = () => (
  <ServicePage
    pillar="CAPABILITY 03"
    title="Go-to-Market"
    ctaLabel="Discuss a Go-to-Market challenge"
    canonical="/services/go-to-market"
    seoTitle="Go-to-Market | Skandor Technologies"
    seoDescription="Positioning, launch strategy, adoption and commercial momentum — so the product finds its market, not the other way around."
    headline="Positioning, launch and commercial momentum."
    lede="Go-to-market is where product meets buyer. We shape positioning, sequence the launch, and build the adoption engine — so the market pulls the product forward instead of the team pushing it into a vacuum."
    includes={[
      "Positioning and messaging tied to the buyer's actual decision",
      "Launch plan sequenced across product, sales and marketing",
      "Adoption engine: activation, retention and expansion loops",
      "Pricing and packaging pressure-tested against real deals",
      "Instrumentation so leadership can read commercial momentum weekly",
    ]}
    deliverables={[
      "Positioning, messaging and launch plan",
      "Adoption engine in-market with measured pipeline and retention",
      "Commercial dashboard leadership actually uses",
    ]}
    stages={[
      { n: "02", title: "Shape", body: "Convert product strategy into buyer-facing positioning and a launch plan." },
      { n: "04", title: "Launch & Scale", body: "Run the launch and harden the adoption engine as volume grows." },
      { n: "05", title: "Optimize & Reinvent", body: "Tune conversion, retention and expansion against weekly commercial signal." },
    ]}
  />
);

export default Systems;
